
























import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import * as Routes from "@/employer/route-names";
import { DrivewealthAccountSummary, InvestmentCustodian } from "@/shared/types";
import { Location } from "vue-router";
import _ from "lodash";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InvestmentAccountLink from "@/shared/components/investments/InvestmentAccountLink.vue";
import * as SharedRoutes from "@/shared/route-names";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useHsaDailyBalanceStore } from "@/shared/store/hsaDailyBalance";

@Component({
  components: {
    GenericLoadingSpinner,
    InvestmentAccountLink
  }
})

export default class InvestmentAccount extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  drivewealthStore = useDrivewealthStore();
  featureFlagStore = useFeatureFlagStore();
  hsaDailyBalanceStore = useHsaDailyBalanceStore();

  @Prop()
  page: number;

  @Prop()
  routeToPages: (page: number) => Location;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: false })
  accountId: number;

  mounted (): void {
    if (this.accountId) {
      this.drivewealthStore.getAccountSummaryV2({
        username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId
      });
    } else {
      this.drivewealthStore.loadAccountSummary({ username: this.username, partnerId: this.partnerId, force: true });
      this.drivewealthStore.loadDefaultAccount({ username: this.username, partnerId: this.partnerId });
    }

    this.custodianSettingsStore.getCustodianSettings({ username: this.username, partnerId: this.partnerId } as any);
    this.investmentDailyBalanceStore.loadCurrentDailyBalance({ username: this.username, partnerId: this.partnerId });
    this.tryRedirectToCustodian();
  }

  get isPageLoaded () {
    const accountSummaryV2Loaded = this.accountId ?
      this.drivewealthStore.accountSummaryV2Loaded(this.accountId) :
      this.drivewealthStore.accountSummaryLoaded;

    return this.custodianSettingsStore.isLoaded &&
      this.investmentDailyBalanceStore.currentBalanceIsLoaded &&
      this.drivewealthStore.drivewealthLoaded &&
      accountSummaryV2Loaded;
  }

  get hasCustodian () {
    return this.isPageLoaded &&
      this.custodianSettingsStore.investmentCustodian &&
      this.custodianSettingsStore.investmentCustodian !== InvestmentCustodian.None;
  }

  get drivewealthLocation (): Location {
    if (this.featureFlagStore.flags.bend15911EnableDrivewealthMultiAccountViews) {
      let defaultAccountId = 0;
      const dwAccounts = _.orderBy(this.drivewealthStore.accounts.items, x => x.drivewealthAccountId);

      if (dwAccounts.length) {
        const mostRecentAccount = _.last(dwAccounts);
        defaultAccountId = mostRecentAccount.drivewealthAccountId;
      }

      const route = {
        name: SharedRoutes.DrivewealthInvestmentAccountV2,
        params: { partnerId: `${this.partnerId}`, accountId: `${defaultAccountId}` },
        query: { username: this.username }
      };
      return route;
    }

    return this.getRoute(SharedRoutes.DrivewealthInvestmentAccount);
  }

  get tdaLocation (): Location {
    return this.getRoute(Routes.TdaInvestmentAccount);
  }

  get accountSummaryV2 (): DrivewealthAccountSummary {
    if (this.accountId) {
      return this.drivewealthStore.accountSummaryById(this.accountId);
    }
    return this.drivewealthStore.accountSummary;
  }

  get drivewealthButtonBalance (): number {
    if (this.drivewealthStore.hasAnAccount) {
      return this.accountSummaryV2.equityValue;
    }

    return undefined;
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange () {
    this.tryRedirectToCustodian();
  }

  @Watch("custodianSettingsStore.investmentCustodian")
  @Watch("investmentDailyBalanceStore.currentBalanceIsLoaded")
  @Watch("custodianSettingsStore.isLoaded")
  @Watch("drivewealthStore.drivewealthLoaded")
  tryRedirectToCustodian () {
    if (!this.isPageLoaded) { return; }

    const location = this.investmentLandingLocation();

    if (!location) { return; }

    this.$router.replace(location);
  }

  investmentLandingLocation (): Location {
    switch (this.custodianSettingsStore.investmentCustodian) {
      case InvestmentCustodian.Umb:
        return this.getRoute(Routes.UmbInvestmentAccount);

      case InvestmentCustodian.Drivewealth:
        return this.drivewealthLocation;
      case InvestmentCustodian.Tda:
        return this.drivewealthLocation;
      case InvestmentCustodian.HsaBank:
        return this.getRoute(Routes.HsabInvestmentAccount);

      default:
        return null;
    }
  }

  getRoute (routeName: string): Location {
    return {
      name: routeName,
      query: {
        username: this.username
      },
      params: {
        partnerId: this.partnerId.toString()
      }
    };
  }
}
